import React from "react";
import { Route } from "react-router-dom";
import { URL } from "../url";
import PrivateRoute from "../component/private_route";
import LayoutRoot from "../layout/layout_root";
import BranchManagementScreen from "../../02_Branch_Listing/branch_management";
import BranchTabAdd from "../../02_Branch_Tab/branch_tabs_add";
import BranchTabEdit from "../../02_Branch_Tab/branch_tabs_edit";
import AccountScreen from "../../03_Account/account";
import SettingTab from "../../04_Setting_Tab/setting_tab";
import BranchVoucherAdd from "../../05_Voucher/branch_voucher_add";
import BranchVoucherDetail from "../../05_Voucher/branch_voucher_edit";
import BranchStaffDetail from "../../06_Staff/branch_staff_detail";
import RosterScreen from "../../07_Roster/roster_screen";
import RequestManagement from "../../08_Request/request";
import ReportScreen from "../../09_Report/report_screen";
import TimeTracking from "../../09_Time_Tracking/time_tracking";
import CashupIncomeByStaff from "../../09_Income_By_Staff/income_by_staff";
import IncomeStaff from "../../09_Income_By_Staff_Details/income_staff";
import CashupReportList from "../../09_Cashup_Report_List/cashup_report_list";
import CashupScreen from "../../09_Cashup_Report_Detail/cashup_screen";
import PayoutScreen from "../../12_Payout/payout_screen";
import PayoutListScreen from "../../12_Payout_List/payout_screen";
import PayoutSettingScreen from "../../12_Payout_Setting/payout_setting_screen";
import PayoutReportScreen from "../../09_Payout_Report/payout_report_screen";
import PayrateBonusScreen from "../../12_Payrate_Bonus/payrate_bonus_screen";
// import DevScreen from "../../16_Dev/dev_screen";
import UserScreen from "../../11_User/user_screen";
// import { useSelector } from "react-redux";
// import { isOwnerSelector } from "../../../store/role/role.selector";

export const routerPrivate = () => {
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------

  return (
    <Route exact path={URL.home} element={<LayoutRoot />}>
      <Route
        index
        element={<PrivateRoute element={<BranchManagementScreen />} />}
      />
      <Route
        path={URL.branchAdd}
        element={<PrivateRoute element={<BranchTabAdd />} />}
      />
      <Route
        path={URL.branchDetail}
        element={<PrivateRoute element={<BranchTabEdit />} />}
      />
      <Route
        path={URL.account}
        element={<PrivateRoute element={<AccountScreen />} />}
      />
      <Route
        path={URL.setting}
        element={<PrivateRoute element={<SettingTab />} />}
      />
      <Route
        path={URL.voucherAdd}
        element={<PrivateRoute element={<BranchVoucherAdd />} />}
      />
      <Route
        path={URL.voucherDetail}
        element={<PrivateRoute element={<BranchVoucherDetail />} />}
      />
      <Route
        path={URL.staffDetail}
        element={<PrivateRoute element={<BranchStaffDetail />} />}
      />
      {/* // Clone the old system */}
      <Route
        path={URL.roster}
        element={<PrivateRoute element={<RosterScreen />} />}
      />
      <Route
        path={URL.request}
        element={<PrivateRoute element={<RequestManagement />} />}
      />
      <Route
        path={URL.report}
        element={<PrivateRoute element={<ReportScreen />} />}
      />
      <Route
        path={URL.timeTracking}
        element={<PrivateRoute element={<TimeTracking />} />}
      />
      <Route
        path={URL.cashupReportList}
        element={<PrivateRoute element={<CashupReportList />} />}
      />
      <Route
        path={URL.cashupReportDetail}
        element={<PrivateRoute element={<CashupScreen />} />}
      />
      <Route
        path={URL.incomeByStaff}
        element={<PrivateRoute element={<CashupIncomeByStaff />} />}
      />
      <Route
        path={URL.incomeByStaffDetail}
        element={<PrivateRoute element={<IncomeStaff />} />}
      />
      <Route
        path={URL.user}
        element={<PrivateRoute element={<UserScreen />} />}
      />
      <Route
        path={URL.payout}
        element={<PrivateRoute element={<PayoutScreen />} />}
      />
      <Route
        path={URL.payoutList}
        element={<PrivateRoute element={<PayoutListScreen />} />}
      />
      <Route
        path={URL.payoutSetting}
        element={<PrivateRoute element={<PayoutSettingScreen />} />}
      />
      <Route
        path={URL.payoutReport}
        element={<PrivateRoute element={<PayoutReportScreen />} />}
      />
      <Route
        path={URL.payrateBonus}
        element={<PrivateRoute element={<PayrateBonusScreen />} />}
      />
      {/* <Route
        path={URL.dev}
        element={<PrivateRoute element={<DevScreen />} />}
      /> */}
    </Route>
  );
};
